"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Badge(props) {
    var native = props.native, style = props.style;
    var text = native.desc2 === 'content' ? 'Annonsørinnhold' : 'Annonse';
    return (React.createElement("div", { style: style },
        React.createElement("div", { style: {
                display: 'flex',
                flexWrap: 'wrap',
                maxWidth: '100%',
            } },
            React.createElement("div", { style: {
                    border: '1px solid rgb(195, 204, 217)',
                    marginRight: '3px',
                    borderRadius: '4px',
                    padding: '0px 2px',
                    display: 'inline-table',
                    float: 'left',
                } }, text),
            React.createElement("div", { style: {
                    marginTop: '1px',
                    float: 'left',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '50ch',
                } }, native.sponsoredBy))));
}
exports.default = Badge;
